import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { LIST_PROCESSOR_POOL_QUERY_KEY } from '@/state/queries/processor-admin/use-list-processor-pool';

async function reissueProcessorToken(token: string, playerId: string) {
  const url = `${import.meta.env.VITE_API_URL}/processor/players/${encodeURIComponent(playerId)}/reissue-token`;
  return sendJSONRequest({ url, method: METHOD.POST, token });
}

async function recoverProcessor(token: string, playerId: string, body: { mode?: 'auto' | 'soft' | 'hard' }) {
  const url = `${import.meta.env.VITE_API_URL}/processor/players/${encodeURIComponent(playerId)}/recover`;
  return sendJSONRequest({ url, method: METHOD.POST, token, body });
}

export function useReissueProcessorTokenMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (playerId: string) => {
      const token = await getToken();
      return reissueProcessorToken(token ?? '', playerId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [LIST_PROCESSOR_POOL_QUERY_KEY] });
    },
  });
}

export function useRecoverProcessorMutation() {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { playerId: string; mode?: 'auto' | 'soft' | 'hard' }) => {
      const token = await getToken();
      return recoverProcessor(token ?? '', params.playerId, { mode: params.mode ?? 'auto' });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [LIST_PROCESSOR_POOL_QUERY_KEY] });
    },
  });
}
